<div class="main-container">
  @let inputClass = "flex flex-column gap-spacing-default";

  <div class="login-container">
    <div class="login-form radius-xl flex flex-column gap-spacing-5xl">
      <div class="container-header gap-spacing-xl flex flex-column">
        <div class="image-container">
          <img src="/assets/icons/logo-adroit-login.svg" alt="logo-adroit-login" />
        </div>

        <div class="header-typography gap-spacing-default flex flex-column">
          <div class="headline-small-bold text-primary-color">
            Welcome Back! 👋
          </div>
          <div class="body-medium-regular text-caption-color">
            Login to your Driver Provider account
          </div>
        </div>
      </div>

      <form [formGroup]="loginForm" class="container-form gap-spacing-xl flex flex-column">
        <div [class]="inputClass">
          <label class="input-label label-large-medium" for="email">Email</label>
          <div class="k-input-wrapper">
            <input id="email" formControlName="email" class="p-inputtext" type="text" placeholder="you@email.com"
              (blur)="onBlurEmail()" autocomplete="off" pInputText [class.ng-invalid]="loginForm.errors?.['invalidLogin']"/>
          </div>
          @if (
          email?.errors?.['required'] && email?.invalid && email?.touched) {
<small class="input-helper-text">Please enter a valid email address.
          </small>
}

          @if (
                email?.errors?.['pattern'] && email?.invalid && email?.touched
                ) {
<small class="input-helper-text">Wrong email, please try again..</small>
}
          @if (
                loginForm.errors?.['invalidLogin']
                ) {
<small class="input-helper-text">Wrong email, please try again..</small>
}
        </div>

        <div [class]="inputClass">
          <label class="input-label label-large-medium" for="password">Password</label>
          <div class="k-input-wrapper">
            <input id="password" formControlName="password" class="p-inputtext"
              [type]="passwordVisible ? 'text' : 'password'" placeholder="Password" pInputText [class.ng-invalid]="loginForm.errors?.['invalidLogin']"/>
            <em class="right-icon" [ngClass]="passwordVisible ? 'icon-eye' : 'icon-eye-slash'"
              (click)="togglePasswordVisibility()" (keydown)="handleKeydown($event)">

            </em>
          </div>
          @if (password?.errors?.['required'] &&
          password?.invalid &&
          password?.touched) {
<small class="input-helper-text">Please enter a valid password</small>
}

          @if (loginForm.errors?.['invalidLogin']) {
<small class="input-helper-text">Wrong password, please try again.</small>
}
        </div>
        <p-button class="p-button-md login-button" severity="primary" [disabled]="loginForm.invalid"
          (onClick)="onSubmit()">
          @if(!(loadingState$ | async)){
          Login
          }@else {
          <em class="icon-circle-notch spin text-xl"></em>
          }
        </p-button>

      </form>

      <div class="container-divider flex justify-content-between">
        <hr class="divider-line w-full border-neutral-base-seperator-bg" />
        <span class="label-medium-medium text-caption-color px-spacing-xs">Or</span>
        <hr class="divider-line w-full border-neutral-base-seperator-bg" />
      </div>

      <div class="container-third-login flex flex-column gap-spacing-lg login-button
      ">


        <p-button class="p-button-md background-soft-primary-bg"
         [outlined]="true"
          severity="secondary"
          onclick="handleGoogleLogin(); return false;"
          [disabled]="(loadingState$ | async)"
          (keydown.enter)="0">
            <img
              alt="Google"
              width="15"
              height="13"
              src="assets/icons/google.svg"
            />
            <span class="body-large-medium text-tretiary-color">Sign in with Google</span>
        </p-button>




        <p-button class="p-button-md background-soft-primary-bg" [outlined]="true" severity="secondary"
          [disabled]="(loadingState$ | async)"
          (click)="signInWithMicrosoft()"
          (keydown.enter) = "signInWithMicrosoft()"
          >
          <img src="/assets/icons/microsoft.svg" alt="microsoft" />
          <span class="body-large-medium text-tretiary-color">Sign in with Microsoft</span>

        </p-button>
      </div>

      <div class="container-terms flex gap-spacing-default justify-content-center flex-wrap">
        <span class="body-medium-regular text-caption-color">By signing in I agree to ADROIT</span> <a
          class="label-large-medium text-link-color" href="https://www.goadroit.com/terms-of-service">Terms of
          Service.</a>
      </div>
    </div>
  </div>
  <div class="image-container"></div>
</div>
